export const addCompanyFormField = [
	{
		type: 'select',
		title: 'Company Name',
		placeholder: 'select company',
		formControlName: 'selectCompany',
		required: true,
		errorsMsg: [{ type: 'required', message: 'select company' }],
	},
];
